import React from 'react'
import Loadable from 'react-loadable'
import Box from '../box/Box'
import GridContainer from '../gridcontainer/GridContainer'
import LoadingSpinner from '../loading-spinner/LoadingSpinner'
import Text from '../typography/text/Text'
import {UniLink} from '../unilink/index'

function Loading(props) {
  if (props.error) {
    return (
      <GridContainer>
        <Box display='flex' alignItems='center' justifyContent='center'>
          <Box>
            <Text>Error! <UniLink onClick={ props.retry }>Retry</UniLink></Text>
          </Box>
        </Box>
      </GridContainer>
    )
  } else if (props.timedOut) {
    return (
      <GridContainer>
        <Box display='flex' alignItems='center' justifyContent='center'>
          <LoadingSpinner noMargin />
          <Box marginTop={4}>
            <Text>Taking a long time... <UniLink onClick={ props.retry }>Retry</UniLink></Text>
          </Box>
        </Box>
      </GridContainer>
    )
  } else if (props.pastDelay) {
    return (
      <GridContainer>
        <Box display='flex' alignItems='center' justifyContent='center' direction='column'>
          <LoadingSpinner noMargin />
        </Box>
      </GridContainer>
    )
  } else {
    return null
  }
}


// This doesn't work because of relative paths. In any case, this is the form
// that the opts should take
export function createOpts(componentPath) {
  return {
    loader: () => import(componentPath),
    modules: [componentPath],
    webpack: () => [require.resolveWeak(componentPath)]
  }
}

export default function asyncComponent(opts) {
  return Loadable(Object.assign({
    loading: Loading,
    delay: 200,
    timeout: 10000,
  }, opts))
}



// WEBPACK FOOTER //
// ./src/core/components/async-component/AsyncComponent.js